import { degreeAbbr } from 'angle-to-direction';

export interface IUseWeatherDataParser {
  direction: (degrees: number) => string,
  directionToIconMapper: (direction: string) => string,
}

export default (): IUseWeatherDataParser => {
  const direction = (degrees: number): string => degreeAbbr(degrees);

  const directionToIconMapper = (directionCode: string): string => {
    // switch dla zachowania typów zmiennych w typescript
    switch (directionCode) {
      case 'N':
        return 'icomoon-meteo-direction-n';
      case 'NE':
        return 'icomoon-meteo-direction-ne';
      case 'E':
        return 'icomoon-meteo-direction-e';
      case 'SE':
        return 'icomoon-meteo-direction-se';
      case 'S':
        return 'icomoon-meteo-direction-s';
      case 'SW':
        return 'icomoon-meteo-direction-sw';
      case 'W':
        return 'icomoon-meteo-direction-w';
      case 'NW':
        return 'icomoon-meteo-direction-nw';
      default:
        return '';
    }
  };

  return {
    direction,
    directionToIconMapper,
  };
};
